import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
//import './createCharger.css';
import { editCharger } from '../../utils/queries/hostQueries';
import { toast } from 'react-toastify';
import { createUseStyles } from 'react-jss';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '700px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
  disableButton: {
    marginTop: '15px',
    width: '150px',
    backgroundColor: '#eb5857',
    color: 'white',
    border: '1px solid #eb5857',
    '&:hover': {
      backgroundColor: '#eb5857',
      color: 'white',
      border: '1px solid #eb5857',
    },
  },
  cancelButton: {
    marginTop: '15px',
    backgroundColor: 'white',
    color: '#2675b8',
    border: '1px solid #2675b8',
    '&:hover': {
      backgroundColor: 'white',
      color: '#2675b8',
      border: '1px solid #2675b8',
    },
  },
  addCharger: {
    backgroundColor: '#2675b8',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    marginTop: '15px',
    width: '100%',
  },
  timeRangePickerFrom: {
    width: '36%',
    marginLeft: '11px',
    borderRadius: '6px',
    padding: '3px',
    backgroundColor: 'white',
    border: '1px solid #d4d9df',
  },
});

export default function CreateChargerModal({
  toggleDisableChargerModalOpen,
  disableChargerModalOpen,
  charger,
}) {
  const classes = useStyles();
  const queryQlient = useQueryClient();
  const { mutateAsync: updateCharger } = useMutation(editCharger);

  const [disablingCharger, setDisablingCharger] = useState(false);

  //Actually update the charger
  async function disableCharger() {
    try {
      setDisablingCharger(true);
      const formattedValues = {
        ID: charger.ID,
        IS_ENABLED: 0,
      };
      const updatedCharger = await updateCharger(formattedValues);

      queryQlient.setQueryData(['host/charger', charger.ID], (oldData) => {
        return updatedCharger;
      });
      queryQlient.fetchQuery(['host/charger', charger.ID]);
      queryQlient.fetchQuery('host/chargers');

      toast.dark('Charger disabled.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      toggleDisableChargerModalOpen();
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setDisablingCharger(false);
  }

  return (
    <Modal
      isOpen={disableChargerModalOpen}
      toggle={toggleDisableChargerModalOpen}
      className={classes.modal}
      centered
      backdrop="static"
    >
      <ModalHeader toggle={toggleDisableChargerModalOpen}>
        Disable Charger
      </ModalHeader>
      <ModalBody style={{ marginTop: '-30px' }}>
        <div className="row">
          <div className="col-12">
            Are you sure, you want to disable the Charger <b>{charger.NAME}</b>
          </div>
        </div>
        <div className="row">
          <div
            className="col-12"
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Button
              className={classes.cancelButton}
              onClick={toggleDisableChargerModalOpen}
            >
              Cancel
            </Button>
            <Button className={classes.disableButton} onClick={disableCharger}>
              {disablingCharger ? 'Processing...' : 'Disable'}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
